
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IRootState } from "@/store/types";
import { subMonths } from "date-fns";
import {
  LOYALTY,
  emptyCustomerSearch,
  emptyAccountOffer
} from "@/store/loyalty";
import { LOYALTY_MARKETING, PRICING_TEAM } from "@/constants/roles";
import { isInSomeRole } from "@/helpers/auth";
import { ICustomerSearchResponse, OfferLevelType } from "@/store/loyalty/types";

export default Vue.extend({
  data() {
    return {
      customersRouteName: LOYALTY_ROUTE_NAMES.CUSTOMERS,
      accountOffersRoute: LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS_DETAILS,
      pointsRouteName: LOYALTY_ROUTE_NAMES.POINTS
    };
  },
  computed: {
    customerId() {
      const id = this.$route.params.id;
      return id ? Number(id) : null;
    },
    customerName() {
      return this.customer && this.customer.customerName;
    },
    accountNumber() {
      return this.customer && this.customer.accountNumber;
    },
    emailAddress() {
      return this.customer && this.customer.emailAddress;
    },
    customerOffer() {
      return this.customer && this.customer.offer;
    },
    invoiceEmailAddress() {
      return this.customer && this.customer.invoiceEmailAddress;
    },
    isEligible() {
      return this.customerOffer && this.customerOffer.isEligible;
    },
    level() {
      return this.customerOffer && this.customerOffer.level;
    },
    segment() {
      return this.customer && this.customer.segment;
    },
    channels() {
      return (this.customerOffer && this.customerOffer.channels) || [];
    },
    isAccountOffer() {
      return this.customerOffer && this.customerOffer.isAccountOffer;
    },
    showEditButton() {
      return (
        this.isAccountOffer && isInSomeRole([LOYALTY_MARKETING, PRICING_TEAM])
      );
    },
    showCardUpdate() {
      return this.level === OfferLevelType.Card;
    },
    ...mapState({
      customer: (state: IRootState) => state.loyalty.customer,
      items: (state: IRootState) => state.loyalty.customerCardsList
    }),
    ...mapGetters({
      totalAirpoints: LOYALTY.NS(LOYALTY.GETTERS.GET_CUSTOMER_AIRPOINTS_TOTAL),
      totalFlybuys: LOYALTY.NS(LOYALTY.GETTERS.GET_CUSTOMER_FLYBUYS_TOTAL)
    })
  },
  methods: {
    onEditButton() {
      this.$router.push({
        name: this.accountOffersRoute,
        params: { id: this.accountNumber }
      });
    }
  },

  async mounted() {
    // reset existing values
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.SET_CUSTOMER), {});
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.SET_CUSTOMER_CARDS), []);

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), true);

    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER),
      this.customerId
    );

    const lastMonth = subMonths(new Date(), 1);

    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER_POINTS),
      {
        accountNumber: this.customerId,
        month: lastMonth.getMonth() + 1,
        year: lastMonth.getFullYear()
      }
    );

    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER_CARDS),
      { customerId: this.customerId }
    );

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), false);
  }
});
